import React, { createContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import toast from "react-hot-toast";
import {
  getData,
  postData,
  putData,
  deleteData,
  getDownloadDataExcel,
} from "./api";
import { formatDate } from "./apis/enquiry_form/Enquiry_Form";
export const Context = createContext();

const AppContext = ({ children }) => {
  console.log("dfsffffd");



  const IMG_URL = "http://127.0.0.1:8520";
  const navigate = useNavigate();

  const [signin, setSignin] = useState(false);
  // const [language, setLanguage] = useState(1);
  const [usertype, setUsertype] = useState("");

  const [userdata, setUserData] = useState({});

  const [appSetup, setAppSetup] = useState({});
  const [isAllow, setisAllow] = useState([]);

  const [shimmerLoader, setShimmerLoader] = useState(false);
  const minLength = 2;
  const maxLength = 30;

  // const getUser = async () => {
  //   const res = await UserGet();
  //   if (res?.success) {
  //     setUserData(res.data);
  //   }
  // };

  useEffect(() => {
    // Get current URL params
    const params = new URLSearchParams(window.location.search);

    // Loop through each parameter and set in cookies
    params.forEach((value, key) => {
      Cookies.set(key, value, { expires: 7 }); // Store for 7 days
    });

  }, []);

  useEffect(() => {
    isTokenValid();
  }, [signin]);

  const isTokenValid = async () => {

    const token = Cookies.get("finance_security");

    if (token) {
      // Decode the token to get the expiration time
      const decodedToken = JSON.parse(atob(token.split(".")[1]));
      const currentTime = Date.now() / 1000;

      // Check if the token has expired
      if (decodedToken.exp < currentTime) {
        Cookies.remove("finance_security", { path: "/" });
        setSignin(false);
        setUsertype("");
        setisAllow([]);
        navigate("/");
      } else {
        setisAllow(decodedToken?.permissions);
        // getuserData(decodedToken.user);
        setUsertype(decodedToken.rolename);


      }
    } else {
      setisAllow([]);
      await setSignin(false);
      setUsertype("");
      // navigate("/");
    }
  };

  const ErrorNotify = (name) => {
    toast.error(`${name} deleted successfully.`, {
      position: "top-right",
      autoClose: 100,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
      style: { background: "red", color: "white" },
    });
  };

  // Togle
  const [isSidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => {
    setSidebarOpen(!isSidebarOpen);
  };

  return (
    <Context.Provider
      value={{
        IMG_URL,
        getData,
        postData,
        putData,
        deleteData,
        minLength,
        maxLength,
        signin,
        setSignin,
        usertype,
        setUsertype,
        userdata,
        setUserData,
        getDownloadDataExcel,
        ErrorNotify,
        setAppSetup,
        appSetup,
        // token,
        // setToken,
        toggleSidebar,
        isSidebarOpen,
        setSidebarOpen,
        shimmerLoader,
        setShimmerLoader,
        isTokenValid,
      }}
    >
      {children}
    </Context.Provider>
  );
};

export default AppContext;
